module.exports = __webpack_public_path__ + "images/energy-label-water-a-xxl.d7c0c0.svg";